/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Login History API
 * API for managing user login history tracking
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Record user login history with device and location information
 * @summary Save login history
 */
export const saveLoginHistoryBodyIpAddressMax = 45;

export const saveLoginHistoryBodyDeviceNameMax = 255;

export const saveLoginHistoryBodyLoginMethodDefault = `email`;
export const saveLoginHistoryBodyLoginMethodMax = 20;

export const saveLoginHistoryBodyIsSuccessfulDefault = 1;
export const saveLoginHistoryBodyFailureReasonMax = 255;

export const SaveLoginHistoryBody = zod
    .object({
        ip_address: zod.string().max(saveLoginHistoryBodyIpAddressMax).optional().describe("IP address of the login"),
        user_agent: zod.string().optional().describe("Browser user agent string"),
        device_name: zod
            .string()
            .max(saveLoginHistoryBodyDeviceNameMax)
            .optional()
            .describe("Device name or identifier"),
        login_method: zod
            .string()
            .max(saveLoginHistoryBodyLoginMethodMax)
            .default(saveLoginHistoryBodyLoginMethodDefault)
            .describe("Login method (email, web, facebook, etc.)"),
        is_successful: zod
            .number()
            .default(saveLoginHistoryBodyIsSuccessfulDefault)
            .describe("Whether the login was successful"),
        failure_reason: zod
            .string()
            .max(saveLoginHistoryBodyFailureReasonMax)
            .optional()
            .describe("Reason for login failure if unsuccessful"),
    })
    .strict();

export const saveLoginHistory201ResponseDataIpAddressMax = 45;

export const saveLoginHistory201ResponseDataDeviceNameMax = 255;

export const saveLoginHistory201ResponseDataLoginMethodDefault = `email`;
export const saveLoginHistory201ResponseDataLoginMethodMax = 20;

export const saveLoginHistory201ResponseDataIsSuccessfulDefault = 1;
export const saveLoginHistory201ResponseDataFailureReasonMax = 255;

export const SaveLoginHistory201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        data: zod
            .object({
                login_history_id: zod.number().describe("Unique login history identifier"),
                user_id: zod.number().describe("User identifier"),
                ip_address: zod
                    .string()
                    .max(saveLoginHistory201ResponseDataIpAddressMax)
                    .optional()
                    .describe("IP address of the login"),
                user_agent: zod.string().optional().describe("Browser user agent string"),
                device_name: zod
                    .string()
                    .max(saveLoginHistory201ResponseDataDeviceNameMax)
                    .optional()
                    .describe("Device name or identifier"),
                login_method: zod
                    .string()
                    .max(saveLoginHistory201ResponseDataLoginMethodMax)
                    .default(saveLoginHistory201ResponseDataLoginMethodDefault)
                    .describe("Login method (email, web, facebook, google, etc.)"),
                is_successful: zod
                    .number()
                    .default(saveLoginHistory201ResponseDataIsSuccessfulDefault)
                    .describe("Whether the login was successful"),
                failure_reason: zod
                    .string()
                    .max(saveLoginHistory201ResponseDataFailureReasonMax)
                    .optional()
                    .describe("Reason for login failure if unsuccessful"),
                created_at: zod.string().datetime({ offset: true }),
                updated_at: zod.string().datetime({ offset: true }),
            })
            .strict()
            .optional(),
        message: zod.string().optional(),
    })
    .strict();

export const SaveLoginHistory400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const SaveLoginHistory401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const SaveLoginHistory422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Validation error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Field validation messages"),
        status_code: zod.literal(422).describe("HTTP status code"),
    })
    .strict();

export const SaveLoginHistory500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * Retrieve login history for a specific user
 * @summary Get login history by user
 */

export const GetHistoryByUserParams = zod
    .object({
        user_id: zod.number().min(1).describe("User identifier"),
    })
    .strict();

export const getHistoryByUserQueryLimitDefault = 20;
export const getHistoryByUserQueryLimitMax = 100;

export const GetHistoryByUserQueryParams = zod
    .object({
        limit: zod
            .number()
            .min(1)
            .max(getHistoryByUserQueryLimitMax)
            .default(getHistoryByUserQueryLimitDefault)
            .describe("Maximum number of records to return"),
    })
    .strict();

export const getHistoryByUser200ResponseDataItemIpAddressMax = 45;

export const getHistoryByUser200ResponseDataItemDeviceNameMax = 255;

export const getHistoryByUser200ResponseDataItemLoginMethodDefault = `email`;
export const getHistoryByUser200ResponseDataItemLoginMethodMax = 20;

export const getHistoryByUser200ResponseDataItemIsSuccessfulDefault = 1;
export const getHistoryByUser200ResponseDataItemFailureReasonMax = 255;

export const GetHistoryByUser200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        data: zod
            .array(
                zod
                    .object({
                        login_history_id: zod.number().describe("Unique login history identifier"),
                        user_id: zod.number().describe("User identifier"),
                        ip_address: zod
                            .string()
                            .max(getHistoryByUser200ResponseDataItemIpAddressMax)
                            .optional()
                            .describe("IP address of the login"),
                        user_agent: zod.string().optional().describe("Browser user agent string"),
                        device_name: zod
                            .string()
                            .max(getHistoryByUser200ResponseDataItemDeviceNameMax)
                            .optional()
                            .describe("Device name or identifier"),
                        login_method: zod
                            .string()
                            .max(getHistoryByUser200ResponseDataItemLoginMethodMax)
                            .default(getHistoryByUser200ResponseDataItemLoginMethodDefault)
                            .describe("Login method (email, web, facebook, google, etc.)"),
                        is_successful: zod
                            .number()
                            .default(getHistoryByUser200ResponseDataItemIsSuccessfulDefault)
                            .describe("Whether the login was successful"),
                        failure_reason: zod
                            .string()
                            .max(getHistoryByUser200ResponseDataItemFailureReasonMax)
                            .optional()
                            .describe("Reason for login failure if unsuccessful"),
                        created_at: zod.string().datetime({ offset: true }),
                        updated_at: zod.string().datetime({ offset: true }),
                    })
                    .strict(),
            )
            .optional(),
        total_count: zod.number().optional(),
    })
    .strict();

export const GetHistoryByUser403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetHistoryByUser404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetHistoryByUser500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(401), zod.literal(403), zod.literal(404), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();
